<button
	class="btn float-btn btn-primary text-white btn-circle btn-circle-sm m-1"
	[class.visible]="isVisible"
	[class.hidden]="!isVisible"
	(click)="scrollToTop()">
	<i class="ph-arrow-up"></i>
</button>
